import { isAPP, getPlatform } from "@environment/type";
import { commonAction } from "@environment/index";

export const setAlias = (data) => {
    if (isAPP()) {
        window.JPush.setAlias({ sequence: 100, alias: data.alias });
    }
}

export const onClearBadge = () => {
    if (getPlatform() == 'ios') {
        window.JPush.setApplicationIconBadgeNumber(0);
    } else {
        window.JPush.setBadgeNumber(0);
    }
}

export const initJpush = () => {
    if (isAPP()) {

        function onDeviceReady() {
            initiateUI();
        };

        function onResume() {
            onClearBadge();
        }

        function getRegistrationID() {
            window.JPush.getRegistrationID(onGetRegistrationID);
        }

        function onGetRegistrationID(data) {

        };

        function onOpenNotification(event) {
            onClearBadge();
            if (getPlatform() == 'ios') {
                if (event.extras && event.extras.path) {
                    //console.log('jpush data: ' + JSON.stringify(event.extras));
                    commonAction('routerPush', {
                        isParams: true,
                        path: event.extras.path,
                        name: event.extras.name ? event.extras.name : event.extras.path,
                        query: event.extras.query ? event.extras.query : [],
                    })
                }
            } else {
                if (event) {
                    var param1 = event["cn.jpush.android.EXTRA"];
                    //alert(param1);
                    var param2 = param1.substring(1, param1.length - 1);
                    var param3 = param2.split(', ');
                    if (param3) {
                        //alert(param3[1]);
                        var path = param3[0].substring(5, param3[0].length);
                        //alert("path: " + path);
                        var query = param3[1].substring(6, param3[1].length);
                        //alert("query: " + query);
                        commonAction('routerPush', {
                            isParams: true,
                            path: path,
                            name: path,
                            query: JSON.parse(query),
                        })
                    }
                }
            }
        };

        function initiateUI() {
            window.JPush.init();
            window.JPush.setDebugMode(true);
            window.setTimeout(getRegistrationID, 1000);
            onClearBadge();
        };


        document.addEventListener("deviceready", onDeviceReady, false);//cordova加载完成后触发事件
        document.addEventListener("resume", onResume, false);//从后台返回 
        document.addEventListener("jpush.openNotification", onOpenNotification, false);//点开通知事件
    }
}


export default {
    setAlias,
    onClearBadge,
    initJpush,
}